import React from "react";
import { useTranslation } from "react-i18next";
import { useChatContext } from "../contexts/chat.context";
import { ROLE_ACCESS_LEVELS } from "../../admin-details/role/constants";
import { ACL_NAMES, useACL } from "../../../hooks/acl";

const MessageModeSelector = () => {
  const { t } = useTranslation("translation", { keyPrefix: "chatSection" });
  const { messagingMode, setMessagingMode } = useChatContext();
  const { getUserACLAccessLevel } = useACL();

  const filters = [
    {
      slug: "chat",
      title: t("chat"),
    },
    ...(getUserACLAccessLevel(ACL_NAMES.ACL_MESSAGING_SEND_MSG) >=
    ROLE_ACCESS_LEVELS.READ
      ? [
          {
            slug: "sms",
            title: t("sms"),
          },
        ]
      : []),
  ];

  const handleFilterChange = (slug: string) => {
    console.log(slug);
    setMessagingMode(slug as "chat" | "sms");
  };

  return (
    <>
      {filters && filters.length > 0 && (
        <>
          <div className="sm:hidden">
            <label htmlFor="Tab" className="sr-only">
              Tab
            </label>

            <select
              id="Tab"
              name="messaging_mode_selector"
              className="w-full rounded-md border-gray-200"
              defaultValue={messagingMode}
            >
              {filters.map((filter, i) => (
                <option key={`select_${i}_${filter.slug}`} value={filter.slug}>
                  {filter.title}
                </option>
              ))}
            </select>
          </div>

          <div className="hidden sm:block">
            <nav
              className="X-mb-px flex gap-3 mb-4 translate-y-1"
              aria-label="Tabs"
            >
              {filters.map((filter, i) => (
                <a
                  className={`shrink-0 flex-grow text-center border-b-2 px-1 py-2 text-sm font-semibold ${filter.slug === messagingMode ? `border-accent-blue-dark text-accent-blue-dark cursor-default` : `border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 cursor-pointer`}`}
                  key={`tab_${i}_${filter.slug}`}
                  onClick={() => handleFilterChange?.(filter.slug)}
                >
                  {filter.title}
                </a>
              ))}
            </nav>
          </div>
        </>
      )}
    </>
  );
};
export default MessageModeSelector;
